import { render, staticRenderFns } from "./OnboardingIndex.vue?vue&type=template&id=9d058a30&scoped=true&"
import script from "./OnboardingIndex.vue?vue&type=script&lang=js&"
export * from "./OnboardingIndex.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingIndex.vue?vue&type=style&index=0&id=9d058a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d058a30",
  null
  
)

export default component.exports